import { render, staticRenderFns } from "./Partnership.vue?vue&type=template&id=71c85d7f&scoped=true&"
import script from "./Partnership.vue?vue&type=script&lang=js&"
export * from "./Partnership.vue?vue&type=script&lang=js&"
import style0 from "./Partnership.vue?vue&type=style&index=0&id=71c85d7f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c85d7f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormSelect: require('/var/www/app/components/FormSelect.vue').default,FormInput: require('/var/www/app/components/FormInput.vue').default,FormTextarea: require('/var/www/app/components/FormTextarea.vue').default,Btn: require('/var/www/app/components/Btn.vue').default,Page: require('/var/www/app/components/Page.vue').default})
